import { render, staticRenderFns } from "./betLimits.vue?vue&type=template&id=24e402cd&scoped=true"
import script from "./betLimits.vue?vue&type=script&lang=js"
export * from "./betLimits.vue?vue&type=script&lang=js"
import style0 from "./betLimits.vue?vue&type=style&index=0&id=24e402cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e402cd",
  null
  
)

export default component.exports